import { render, staticRenderFns } from "./MessagePage.vue?vue&type=template&id=323712b8&lang=pug&"
var script = {}
import style0 from "./MessagePage.vue?vue&type=style&index=0&id=323712b8&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports